<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <vs-card>
      <vs-table
        search
        stripe
        :data="folhas">
        <template slot="header">
          <vs-button
            v-if="canAddPayroll"
            @click="popupAdd = true"
            icon-pack="feather"
            icon="icon-plus"
            color="primary"
            type="border"
            class="mb-2"
            >Criar Novo Processamento</vs-button
          >
        </template>
        <template slot="thead">
          <vs-th sort-key="name">Data de inicio</vs-th>
          <vs-th sort-key="surname">Data de termino</vs-th>
          <vs-th sort-key="surname">Estado</vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :key="indextr"
            v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].start_date">
              {{ data[indextr].start_date }}
            </vs-td>
            <vs-td :data="data[indextr].end_date">
              {{ data[indextr].end_date }}
            </vs-td>

            <vs-td class="font-bold whitespace-no-wrap">
              <vs-chip v-if="data[indextr].status == '0'">
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-dark-gradient'"></div>
                <span>Rascunho</span>
              </vs-chip>
              <vs-chip v-if="data[indextr].status == '1'">
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-primary'"></div>
                <span>Pendente de aprovação</span>
              </vs-chip>
              <vs-chip v-if="data[indextr].status == '2'">
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-success'"></div>
                <span>Aprovada</span>
              </vs-chip>
              <vs-chip v-if="data[indextr].status == '3'">
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-warning'"></div>
                <span>Reprovada</span>
              </vs-chip>
              <vs-chip v-if="data[indextr].status == '4'">
                <div
                  class="h-2 w-2 rounded-full mr-1"
                  :class="'bg-danger'"></div>
                <span>Cancelada</span>
              </vs-chip>
            </vs-td>

            <vs-td
              class="whitespace-no-wrap"
              :data="data[indextr].id">
              <vs-row>
                <!-- <div class="vx-col w-1/1 mb-2">
      <select name="Tipo de componente"  @change="editData" v-validate="'required'" v-model="status" class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
         >
           <option value="" disabled selected hidden>Acção</option>
    <option  value="1">Aprovar</option>
    <option  value="2">Reprovar</option>
    <option  value="3">Cancelar</option>

  </select>
  </div> -->
                <!-- <vs-button class="ml-1 mb-1" :disabled="data[indextr].status=='3'  || data[indextr].status=='2' || data[indextr].status=='1'"  color="warning" size="small" hover:text-danger    @click="popupOpenEdit(tr)">
                        Acções
                    </vs-button> -->
                <!-- <vs-button :disabled="data[indextr].company_id==null" class="ml-2" color="danger"  type="border" size="small" icon-pack="feather" icon="icon-trash" >Detalhes</vs-button> -->
                <vs-button
                  class="ml-1 mb-1"
                  color="success"
                  size="small"
                  icon-pack="feather"
                  icon="icon-log-in"
                  :to="{
                    name: 'processar-salario',
                    params: { folhaId: data[indextr].id }
                  }"
                  >Entrar</vs-button
                >
                <!-- <vs-button class="ml-1 mb-1"  color="success" size="small" hover:text-danger  icon-pack="feather" icon="icon-eye" @click="popupOpenVer(tr)">
                        Visualizar
                    </vs-button> -->
                <!-- <vs-button class="ml-1 mb-1"  color="primary" size="small" hover:text-danger  icon-pack="feather" icon="icon-printer" @click="popupOpenGerar(tr)">
                        Imprimir
                    </vs-button> -->

                <!-- <vs-button  class="ml-2"  color="success" size="small" hover:text-danger  icon-pack="feather" icon="icon-download"  target="_blank" :href="relatorio"  @click="down=false" v-if="relatorio">
                        Download
                    </vs-button> -->
              </vs-row>
              <!-- <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" /> -->
            </vs-td>

            <!-- <vs-td :data="data[indextr].id">
        {{ data[indextr].id }}
      </vs-td> -->
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        class="mt-3"
        :total="totalPage"
        @change="getData()"
        v-model="currentPage"></vs-pagination>
      <div
        style="height: 50px"
        id="div-with-loading"
        class="vs-con-loading__container"></div>
    </vs-card>

    <vs-popup
      v-if="relatorioVer != ''"
      fullscreen
      class="holamundo"
      :title="
        'Folha salarial referente ao Periodo de  ' +
        entrada.start_date +
        ' á ' +
        entrada.end_date
      "
      :active.sync="popupVer">
      <iframe
        id="fred"
        style="border: 0.2px solid #666ccc; overflow-x: scroll"
        title="Folha salarial"
        :src="relatorioVer + '?#zoom=120&toolbar=0&navpanes=0&scrollbar=0&'"
        frameborder="1"
        scrolling="auto"
        width="100%"
        height="600px"></iframe>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Folha salarial"
      :active.sync="popupGerar">
      <div class="form-group form-check">
        <div class="vx-row">
          <div class="vx-col w-1/2 mb-5">
            <label for="">Tamanho da folha</label> <br />

            <v-select
              :options="['A2', 'A3', 'A4']"
              v-model="paperSize"></v-select>
          </div>
          <div class="vx-col w-1/2 mt-3">
            <vs-checkbox
              class="mt-5"
              v-model="checkBox1"
              >Remover colunas</vs-checkbox
            >
          </div>
        </div>
        <div
          v-if="checkBox1 == true"
          class="vx-row">
          <vs-divider></vs-divider>

          <div
            class="vx-col w-1/2 mb-1"
            v-for="item in Items"
            v-bind:key="item.id">
            <input
              type="checkbox"
              style="height: 20px; width: 20px"
              v-model="fruitCollection"
              :id="item"
              :value="item" />
            <label
              class="form-check-label text-sm ml-5"
              :for="item.id"
              >{{ item }}</label
            >
          </div>
        </div>
        <div class="flex flex-wrap items-center flex-start">
          <vs-button
            class="ml-auto mt-2"
            @click="getRelatorio"
            >Gerar</vs-button
          >
          <vs-button
            target="_blank"
            class="ml-4 mt-2"
            type="border"
            color="success"
            iconPack="feather"
            :href="relatorio"
            icon="icon-download"
            @click="(down = false), (relatorio = '')"
            v-if="relatorio"
            >Download</vs-button
          >
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Actualizar estado da folha salarial"
      :active.sync="popupEdit">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label
            class="mt-8"
            for=""
            >Acção</label
          >
          <select
            name="Tipo de componente"
            v-validate="'required'"
            v-model="status"
            class="block w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed">
            <option value="1">Submeter</option>
            <option
              v-if="canApprovePayroll"
              value="2">
              Aprovar
            </option>
            <option
              v-if="canApprovePayroll"
              value="3">
              Reprovar
            </option>
            <option
              v-if="canAddPayroll"
              value="4">
              Cancelar
            </option>
          </select>
        </div>

        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button
              class="ml-auto mt-2"
              @click="editData"
              >Actualizar</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

    <vs-popup
      class="holamundo"
      title="Adicionar Folha Salarial"
      :active.sync="popupAdd">
      <div class="vx-row">
        <div class="vx-col w-full mb-2">
          <label
            class="mt-8"
            for=""
            >Data de Inicio</label
          >
          <vs-input
            class="w-full mt-2 mb-5"
            type="date"
            v-model="start_date"
            v-validate="'required'"
            name="data de inicio" />
          <span
            class="text-danger text-sm"
            v-show="errors.has('data de inicio')"
            >{{ errors.first('data de inicio') }}</span
          >
        </div>

        <div class="vx-col w-full mb-2">
          <label
            class="mt-8"
            for=""
            >Data de termino</label
          >
          <vs-input
            class="w-full mt-2 mb-5"
            type="date"
            v-model="end_date" />
        </div>

        <div class="vx-col w-full mb-2">
          <div class="flex flex-wrap items-center flex-start">
            <vs-button
              class="ml-auto mt-2"
              @click="saveData"
              >Salvar</vs-button
            >
            <vs-button
              class="ml-4 mt-2"
              type="border"
              color="warning"
              @click="popupAdd = false"
              >Cancelar</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  import vSelect from 'vue-select';
  import http from '../../../../../http-common';
  import { PermissionsMixin } from '../../../../mixins/permissions';
  import VxTimeline from '@/components/timeline/VxTimeline.vue';
  // Store Module

  // Cell Renderer

  export default {
    mixins: [PermissionsMixin],
    components: {
      vSelect,
      VxTimeline
    },
    data() {
      return {
        totalPage: '',
        currentPage: '1',
        paginate: 15,
        total: '',

        checkBox1: false,
        paperSize: 'A3',
        Items: [],
        entrada: [],
        start_date: '',
        end_date: '',
        amount: '',
        relatorio: '',
        relatorioVer: '',
        employees: [],
        popupAdd: false,
        popupEdit: false,
        popupGerar: false,
        name: '',
        abbreviation: '',
        type: '',
        components: [],
        component: [
          {
            id: '',
            name: '',
            abbreviation: '',
            type: ''
          }
        ],
        folhas: [],
        popupVer: false,
        paperSize: 'A3',
        currentUser: [],

        timelineData: [
          {
            color: 'primary',
            icon: 'PlusIcon',
            title: 'New Task Added',
            desc: 'Bonbon macaroon jelly beans gummi bears jelly lollipop apple',
            time: '25 Days Ago'
          },
          {
            color: 'warning',
            icon: 'AlertCircleIcon',
            title: 'Task Update Found',
            desc: 'Cupcake gummi bears soufflé caramels candy',
            time: '15 Days Ago'
          },
          {
            color: 'success',
            icon: 'CheckIcon',
            title: 'Task Finished',
            desc: 'Candy ice cream cake. Halvah gummi bears',
            time: '20 mins ago'
          }
        ],
        fruitCollection: [
          'Horas Extras',
          'Imposto sobre o Rendimento de Pessoas Singulares',
          'Instituto Nacional de Segurança Social'
        ],

        status: ''
      };
    },

    mounted() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.getData();
        this.getColumns();
      },

      getData() {
        this.$vs.loading({
          container: '#div-with-loading',
          scale: 1.0,
          type: 'sound'
        });
        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          },
          params: { type: 1, page: this.currentPage, paginate: this.paginate }
        };

        http
          .get('/salaries/payroll-entry', config)
          .then(result => {
            this.$vs.loading.close('#div-with-loading > .con-vs-loading');
            this.folhas = result.data.PayrollEntries.data;
            this.totalPage = result.data.PayrollEntries.last_page;
            this.total = result.data.PayrollEntries.total;
            this.currentPage = '1';
            // alert("2")
          })
          .catch(error => {
            error;

            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      },

      getVisualizar() {
        this.$vs.loading();

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          },
          params: {
            //  selectedColumns: this.Items,
            paperSize: this.paperSize
          }
        };

        http
          .get(`salaries/payroll-entry/${this.entrada.id}`, config)
          .then(result => {
            this.relatorioVer = result.data;
            (this.down = true), this.$vs.loading.close();
          })
          .catch(error => {
            this.err = error.response.data;
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Erro',
              text: this.err,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right'
            });

            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      },

      getRelatorio() {
        this.$vs.loading();

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          },
          params: {
            selectedColumns: this.fruitCollection,
            paperSize: this.paperSize
          }
        };

        http
          .get(`salaries/print-one_payroll_Sheet/${this.entrada.id}`, config)
          .then(result => {
            this.relatorio = result.data;
            (this.down = true), this.$vs.loading.close();
          })
          .catch(error => {
            this.err = error.response.data;
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Erro',
              text: this.err,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right'
            });

            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      },

      async saveData() {
        //      this.$validator.validate('nome').then(result => {
        // if (result) {
        this.$vs.loading();

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          },
          params: { type: 1 }
        };

        const data = {
          start_date: this.start_date,
          end_date: this.end_date
        };

        http
          .post('/salaries/payroll-entry', data, config)
          .then(success => {
            success;
            (this.popupAdd = false),
              (this.start_date = ''),
              (this.end_date = ''),
              this.$vs.loading.close();
            this.getData(),
              this.$vs.notify({
                title: 'Sucesso',
                text: 'Adicionado com sucesso!',
                color: 'success',
                position: 'top-right'
              });

            this.date = '';
            this.amount = '';
            this.reason = '';
            this.selectedEmployee = [];
          })
          .catch(error => {
            error;
            this.err = error.response.data;
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Erro',
              text: this.err,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right'
            });
          });
        // }})
      },

      getColumns() {
        //  this.$vs.loading()

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          }
        };

        http
          .get('/salaries/payrollSheet-columns', config)
          .then(result => {
            //  this.$vs.loading.close()
            this.Items = result.data.Columns;

            //  this.Items= this.components.map(col => ({ name: col.name }));
          })
          .catch(error => {
            error;

            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      },

      getColumns() {
        //  this.$vs.loading()

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          }
        };

        http
          .get(`/salaries/payroll-entry/`, config)
          .then(result => {
            //  this.$vs.loading.close()
            this.folha = result.data;

            //  this.Items= this.components.map(col => ({ name: col.name }));
          })
          .catch(error => {
            error;

            if (error.response.status == 401) {
              this.$router.push('/').catch(() => {});
            }
          });
      },

      popupOpenGerar(entrada) {
        (this.entrada = entrada), (this.popupGerar = true);
      },

      async popupOpenVer(entrada) {
        (this.entrada = entrada), await this.getVisualizar();
        this.popupVer = true;
        this.relatorio = '';
      },
      popupOpenEdit(entrada) {
        (this.entrada = entrada), (this.popupEdit = true);
      },

      async editData() {
        //      this.$validator.validateAll().then(result => {
        // if (result) {
        this.$vs.loading();

        let token = localStorage.getItem('token');
        let config = {
          headers: {
            authorization: 'Bearer ' + token
          }
        };

        const data = {
          status: this.status
        };

        this.$validator.validateAll();
        http
          .patch(`/salaries/approvals/${this.entrada.id}`, data, config)
          .then(success => {
            success;
            (this.popupEdit = false), this.getData(), this.$vs.loading.close();
            this.$vs.notify({
              title: 'Sucesso',
              text: 'Actualizado com sucesso!',
              color: 'success',
              position: 'top-right'
            });
          })
          .catch(error => {
            error;
            this.err = error.response.data;
            this.$vs.loading.close();
            this.$vs.notify({
              title: 'Erro',
              text: this.err,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger',
              position: 'top-right'
            });
          });
        // }})
      }
    }
  };
</script>
